require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;



//////////////////
// WEBPACK FOOTER
// F:/Solutions/6713ge/master/~/core-js/fn/object/assign.js
// module id = 29
// module chunks = 1